import { ValidationSummary } from 'devextreme-react/validation-summary';
import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	MaterialOrderExitButton,
	MaterialOrderFilesButton,
	MaterialOrderNotes,
	NewCFIInformationPanel,
	NewMaterialOrderPage,
	NewMaterialOrderProducts,
	RepricingButton,
	SubmitMaterialOrderButton
} from '../../../features/cfi/material-order';
import '../../../css/order.scss';
import { useTitle } from '../../../contexts/title';
import { useEffect } from 'react';


export default function NewStandaloneMaterialOrderPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Order Stock Material')
	}, [pageTitle])

	return (

		<div className={'content-block order-page'}>

			<NewMaterialOrderPage>

				<Toolbar className='button-toolbar'>
					<ToolbarItem location={'before'}>
						<SubmitMaterialOrderButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<RepricingButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<MaterialOrderFilesButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<MaterialOrderExitButton />
					</ToolbarItem>
				</Toolbar>

				<ValidationSummary validationGroup='newMaterialOrderValidationGroup'></ValidationSummary>

				<Box>
					<Item ratio={1}>
						<NewCFIInformationPanel />
					</Item>
					<Item ratio={1}>
					</Item>
					<Item ratio={1}>
					</Item>
				</Box>

				<NewMaterialOrderProducts />

				<MaterialOrderNotes />

			</NewMaterialOrderPage>
		</div>
	)
}
